var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 327.68,
    height: 31.045,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9171.43 868.93",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 4872.74,
    y1: -8620.73,
    x2: 4717.67,
    y2: 4425.69
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 4616.65,
    y1: 963.09,
    x2: 4616.65,
    y2: 118.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 8402.52,
    y1: -8495.74,
    x2: 8250.7,
    y2: 4751.31
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 700.38,
    y1: -5474.53,
    x2: 586.3,
    y2: 2987.4
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 6575.84,
    y1: -6856.88,
    x2: 6404.47,
    y2: 3517.67
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3425.42,
    y1: -7053.19,
    x2: 3310.46,
    y2: 3734.48
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 9046.39,
    y1: -7322.87,
    x2: 8975.74,
    y2: 4300.53
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 2455.87,
    y1: -6447.97,
    x2: 2363.99,
    y2: 3499.98
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 1590.51,
    y1: -5195.18,
    x2: 1516.75,
    y2: 2811.61
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 695.35c387.1 0 774.95 48.19 1178.76 48.19 145.03 0 1133.11-61.66 1137.59-60.42 617.47 171.18 870.62 157.42 1474.27 91.32 584.26-63.96 1467.36-192.22 2036.89 28.14 464.5 179.72 965.69-79.11 1209.76 33.67 113.26 52.33 1272.96-199.01 1386.49-72.42 200.27 223.34 523.88 23.02 747.66 12V166.29H-.01v529.07z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 529.07c387.1 0 774.95 48.19 1178.76 48.19 145.03 0 1133.11-61.66 1137.59-60.42 617.47 171.18 870.62 157.42 1474.27 91.32 584.26-63.96 1467.36-192.22 2036.89 28.14 464.5 179.72 965.69-79.11 1209.76 33.67 113.26 52.33 1272.96-199.01 1386.49-72.42 200.27 223.34 523.88 23.02 747.66 12V.01H-.01v529.07z",
    style: {
      fill: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 322.86c48.66-31.79 114.75-53.7 235.21-51.99 87.3 1.24 165.44 7.82 239.83 14.08C756.93 308.7 981.76 327.58 1187.96.01h172.57c-14.81 20.26-26.75 36.88-27.48 38.21-259.6 474.32-526.35 451.85-866.25 423.22-75.1-6.33-153.98-12.97-232.61-14.09-143.14-2.03-183.38 36.06-227.97 78.27l-3.66 3.47-2.55-.01V322.86z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.77 0c-17.41 5.45-34.88 11.36-52.06 17.76-53.91 20.08-104.09 44.64-138.1 73.69-16.88 14.41-27.58 25.41-26.98 29.66.11.78.51 2.12 1.22 4.01 57.18 152.32 19.45 232.61-63.43 288.68-35.66 24.13-77.87 39.28-123.47 55.63-27.73 9.94-56.83 20.4-81.62 31.56-12.62 5.68-30.25 10.44-51.28 16.12-43.73 11.8-109.04 29.44-114.78 44.23l-117.01-81.67c34.57-89.31 137.26-117.03 206.02-135.58 16.02-4.33 29.44-7.96 35.3-10.59 32.33-14.56 61.52-25.03 89.35-35.01 39.17-14.05 75.44-27.06 98.22-42.48 11.8-7.97 16.3-21.68 5.18-51.28-6.36-16.95-10.67-34-13.08-51.07-8.43-59.75 4.84-110.53 33.42-153.64h313.1z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943.49 0c-13.72 18.3-29.19 35.54-46.09 51.74-57.89 55.46-134.2 99.19-211.54 130.98-103.2 42.42-209.93 64.25-276.13 64.25-149.66 0-157.04 62.59-164.57 126.46-6.08 51.62-12.21 103.64-31.37 149.01-79.91 4.65-198.73 11.7-328.1 19.21-1.07-2.19-2.46-4.88-3.92-7.73l2.48 7.82-2.48-7.82c-4.61-9.03-9.79-19.74-6.8-21.45 23.18-13.31 46.41-26.65 72.12-27.64 152.49-5.95 160.41-73.18 168.18-139.08 16.43-139.37 32.52-275.94 294.46-275.94 56.29 0 148.13-19.02 237.98-55.95 10.64-4.38 21.24-8.99 31.71-13.86h264.06zM1777.42 547.89l7.4-113.06 96.54 106.5.49.54-104.43 6.02z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2583.98 584.52c29.42-97.16 70.82-109.87 151.33-134.52 24.74-7.58 55.01-16.85 91.71-33.45 114.26-51.69 203.03-87.9 276.3-117.77C3291.73 221.95 3372.09 189.15 3591.67 0h240.82c-13.14 10.47-24.24 19.77-32.53 27.29-343.88 312.06-420.59 343.34-658.49 440.36-70.72 28.83-156.41 63.78-272.69 116.38-40.21 18.18-72.62 28.48-99.42 36.71-58.77-9.68-120.09-21.66-185.37-36.23z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3722.43 615.55c7.82-28.91 22.8-68.07 43.77-111.32 20.44-42.13 46.94-89.17 78.32-135.12C3966.67 190.23 4165.18 20 4389.73 162.1c54.59 34.54 165.53 39.75 285.69 29.86 170.47-14.02 352.2-59.02 428.28-95.86 138.41-67.05 139.99-67.29 197.9-76.21 21.72-3.35 52.17-8.05 98.35-17.92 1.05-.22 2.37-.89 3.97-1.98h196.93c-70.56 92.69-142.82 168.38-180.27 176.39-54.87 11.73-83.56 16.14-104.03 19.31-44.52 6.85-45.74 7.05-168.53 66.52-85.32 41.32-283.18 91.3-464.87 106.25-139.14 11.45-272.66 2.21-349.61-46.49-154.67-97.86-300.28 32.4-392.11 166.89-26 38.06-47.55 76.03-63.97 109.63-29.59 3.34-58.57 6.59-86.84 9.69-23.26 2.54-45.94 5-68.2 7.38z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5295.1 495.37c58.09-103.11 208.63-162.26 376.67-189.8 213.27-34.95 463.89-23.52 571.12 13.2 390.23 133.61 543.31-47.1 731.19-268.87 13.94-16.46 28.05-33.12 42.43-49.9h208.52c-60.16 60.39-113.22 123.02-163.85 182.79-216.7 255.81-393.28 464.26-850.77 307.63-95.09-32.56-323.95-41.63-522.67-9.06-86.62 14.2-165.45 35.05-220.09 63.46-46.08-6.99-93.08-12.72-140.82-17.29l-31.74-32.17z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9084.99 0c-147.1 51.21-336.08 61.13-493.35 69.35-78.44 4.09-148.14 7.74-198.57 15.98-241.22 39.44-248.19 53.09-281.29 118.02-27.42 53.79-66.61 130.66-168.91 247.6-101.93 116.54-176.47 140.3-243.93 158.98-99.23 12.79-197.61 26.2-287.21 37.67 95.92-165.28 169.89-185.64 253.25-208.58 53.88-14.83 113.04-31.11 192.84-122.34 87.76-100.33 121.55-166.61 145.2-213.01 23.72-46.51 40.17-78.76 69-103.69h1012.97z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8682.8 702.53c16.92-20.89 34.41-42.93 52.35-65.52 125.55-158.11 270.33-340.46 434.5-402.17.24-.1.86-.74 1.78-1.86v187.27c-91.37 47.26-181.5 143.86-265.11 244.93-74.5 19.07-150.64 35.98-223.52 37.35z",
    style: {
      fill: "url(#i)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header_bg.4a6addf23287a410033eba4eb33f4185.svg";
export { ForwardRef as ReactComponent };